<script setup lang="ts">
import { computed, defineProps } from 'vue';

const props = defineProps<{
  variant: string | null;
}>();

const VARIANTS = {
  gray: 'bg-gray-50 border-gray-300',
  yellow: 'bg-brand-50 border-brand-500',
  green: 'bg-success-50 border-success-300',
  blue: 'bg-blue-50 border-blue-300',
  pink: 'bg-pink-50 border-pink-300',
  orange: 'bg-orange-50 border-orange-300',
  light_blue: 'bg-sky-50 border-sky-300',
} as const;

function isValidVariant(variant: string): variant is keyof typeof VARIANTS {
  return variant in VARIANTS;
}

const variant = computed(() => {
  if (props.variant === null) {
    return VARIANTS.yellow;
  }

  if (isValidVariant(props.variant)) {
    return VARIANTS[props.variant];
  }

  return VARIANTS.yellow;
});
</script>

<template>
  <div
    class="text-nowrap rounded-full border px-2.5 py-0.5 text-sm font-medium text-gray-700"
    :class="variant"
  >
    <slot></slot>
  </div>
</template>
